<template>
  <div id="app">
    <router-view />
    <news-view v-model="newsVisible"></news-view>
    <attr-dialog
      :global="true"
      v-model="globalModuleVisible"
      :data="globalModuleItem"
    ></attr-dialog>
    <div class="browser-compatibility" v-if="tipVisible">
      建议使用chrome或者safari浏览器
      <a @click="closeDiv"><i class="el-icon-close c-f-right"></i></a>
    </div>
  </div>
</template>

<script>
import newsView from './views/admin/news/news-view'
import attrDialog from './views/components/attr-dialog/attr-dialog'
import util from '@/util.js'
import { mapActions } from 'vuex'
export default {
  name: 'App',
  components: { newsView, attrDialog },
  data () {
    return {
      newsVisible: false,
      showTip: true
    }
  },
  computed: {
    isAdmin () {
      return this.$store.getters['app/isAdmin']
    },
    projectId () {
      return this.$store.state.app.projectId
    },
    globalModuleItem () {
      return this.$store.state.templateGroup.globalModuleItem
    },
    globalModuleVisible () {
      return this.$store.state.templateGroup.globalModuleVisible
    },
    tipVisible () {
      if (!util.isIE()) {
        return false
      }
      let closed = window.sessionStorage.getItem('ie-closed')
      return !closed && this.showTip
    }
  },
  watch: {
    isAdmin (v) {
      if (v) {
        this.$store.dispatch('app/queryAdminProjects')
      }
    },
    projectId: {
      handler () {
        this.init()
      },
      immediate: true
    }
  },
  created () {
    this.init()
  },
  mounted () {
    this.$nextTick(() => {
      this.setClientSize()
      window.onresize = () => this.setClientSize()
    })
  },
  methods: {
    ...mapActions({
      setClientSize: 'app/setClientSize'
    }),
    // setClientSize () {
    //   this.$store.dispatch('app/setClientSize')
    // },
    async init () {
      let { id } = this.$store.state.app.loginUser
      if (this.projectId && id) {
        this.$store.dispatch('app/queryBgColorList', {
          projectId: this.projectId
        })
        // this.$store.dispatch('app/queryTemplateIndexTagList', this.projectId);
        // this.$store.dispatch('app/queryTemplateTagList', this.projectId);
        this.$store.dispatch('app/queryMaterialTags', this.projectId)
        this.$store.dispatch('app/queryTemplateGroupAll', this.projectId)
        this.alertNews()
      }
    },
    alertNews () {
      let dataList = this.$store.state.app.loginUser.ads
      this.newsVisible = dataList && dataList.length > 0
    },
    closeDiv () {
      window.sessionStorage.setItem('ie-closed', 1)
      this.showTip = false
    }
  }
}
</script>
